module.exports = __webpack_public_path__ + "static/img/bg-id.e531e795.png";